import { render } from "./ColumnaIzquierda.vue?vue&type=template&id=53abe14d&scoped=true"
import script from "./ColumnaIzquierda.vue?vue&type=script&lang=js"
export * from "./ColumnaIzquierda.vue?vue&type=script&lang=js"

import "./ColumnaIzquierda.vue?vue&type=style&index=0&id=53abe14d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53abe14d"]])

export default __exports__